// from general.js
/* global dcAnalytics */
// from JSP?
/* global teacherId teacherName */


$(document).ready(function () {
    if ($('.birthday-banner').length > 0 && dcAnalytics) {
        dcAnalytics.track('Birthday Banner', {
            // both 'teacherId' and 'teacherName' come from the JSP
            teacherId: teacherId,
            teacherScreenName: teacherName,
        });
        dcAnalytics.trackEventGANonInteraction([pageName, 'Birthday Banner', teacherId]);
    }
});
